import {
  ImageScaleView,
  ImageScaleViewOpts,
  View,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { Match2RewardItem } from '../components/Match2RewardItem';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import { getRewardName } from '../rewards/match2-rewards.utils';

export class MagicLampsRewardCard extends ImageScaleView {
  private title: LangBitmapFontTextView;
  private reward: Match2RewardItem;

  constructor(opts: ImageScaleViewOpts) {
    super({
      image: 'assets/ui/match2/chest/card_front.png',
      width: 189,
      height: 230,
      centerAnchor: true,
      ...opts,
    });

    const scale = this.style.width / 189;

    this.title = new LangBitmapFontTextView({
      superview: this,
      width: this.style.width - 20,
      height: 60 * scale,
      align: 'center',
      verticalAlign: 'center',
      size: 25 * scale,
      color: '#BF8147',
      font: 'Body',
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: 30 * scale,
    });

    this.reward = new Match2RewardItem({
      superview: this,
      size: 100,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      scale,
    });
  }

  public setup(reward: Match2Reward) {
    this.reward.setReward(reward);
    this.title.localeText = () => getRewardName(reward);
  }

  public grantReward(root: View) {
    return this.reward.grantReward(root);
  }
}
